import { useTranslation } from 'react-i18next';
import styles from './SideMenu.module.css';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';
import { ThemeMenuIcon } from 'components/ThemeMenuIcon/ThemeMenuIcon';
import type { MenuIconKey } from 'lib/menuIcons';
import { openInstallApp } from 'components/InstallApp/InstallApp';
import { useContext } from 'react';
import { UserContext } from 'context/userContext';

const SIDE_MENU_ITEMS: {
  label: string;
  iconKey: MenuIconKey;
  targetUrl: string;
}[] = [
  { label: 'settings_label', iconKey: 'language', targetUrl: '/language' },
  { label: 'contact_label', iconKey: 'contact', targetUrl: '/contact' },
  { label: 'Info', iconKey: 'info', targetUrl: '/info' },
  { label: 'search_label', iconKey: 'search', targetUrl: '/search' },
  {
    label: 'account_statement_label',
    iconKey: 'my-bets',
    targetUrl: '/account-statement',
  },
  {
    label: 'gaming_history_label',
    iconKey: 'casino-games',
    targetUrl: '/gaming-history',
  },
  {
    label: 'account_settings_label',
    iconKey: 'account-settings',
    targetUrl: '/account-settings',
  },
  {
    label: 'become_affiliate_label',
    iconKey: 'contact',
    targetUrl: '/become-affiliate',
  },
  { label: 'about_us_label', iconKey: 'info-circle', targetUrl: '/about-us' },
];

interface Props {
  close: () => void;
}
export const SideMenu = ({ close = () => {} }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { loggedUser, logout } = useContext(UserContext);

  return (
    <div className={styles.wrapper}>
      <div
        className={classNames(styles.menuItem, styles.closeItem)}
        role="button"
        tabIndex={0}
        onClick={close}
      >
        <div className={styles.closeButton} />
        {t('close_label')}
      </div>
      {SIDE_MENU_ITEMS.map((x) => (
        <div
          key={x.targetUrl}
          className={styles.menuItem}
          onClick={() => navigate(x.targetUrl)}
        >
          <ThemeMenuIcon icon={x.iconKey} alt={t(x.label)} variant="footer" />
          {t(x.label)}
        </div>
      ))}
      <div
        className={styles.menuItem}
        role="button"
        tabIndex={0}
        onClick={() => {
          close();
          openInstallApp();
        }}
      >
        <ThemeMenuIcon
          icon="mobile-app"
          alt={t('install_app_label')}
          variant="footer"
        />
        {t('install_app_label')}
      </div>
      {/* Also on the home page; here so a player need not go back to it. */}
      {loggedUser && (
        <div
          className={styles.menuItem}
          role="button"
          tabIndex={0}
          onClick={async () => {
            close();
            await logout();
          }}
        >
          <ThemeMenuIcon
            icon="logout"
            alt={t('logout_label')}
            variant="footer"
          />
          {t('logout_label')}
        </div>
      )}
    </div>
  );
};
